import * as React from 'react';
import { FunctionComponent, PropsWithChildren } from 'react';

import { FormControl } from '@mui/material';

import BaseFormInputField from '../../../../../../shared/components/base-input-form-field/base-form-input-field';
import { BasicInfoComponentProps } from '../../types/basic-info-component.props';

export const MaxRetryNoInput: FunctionComponent<BasicInfoComponentProps> = (
  props: PropsWithChildren<BasicInfoComponentProps>
) => {
  const { values, errors, touched, handleChange, handleBlur } = props;

  return (
    <FormControl data-testid="max-retry-no-input-form-control">
      <BaseFormInputField
        id="max-retry-no"
        label="Max Retry No."
        type="number"
        name="maxRetryNo"
        value={values.maxRetryNo ?? ''}
        onBlur={handleBlur}
        onChange={handleChange}
        error={!!errors.maxRetryNo && touched.maxRetryNo}
        helperText={
          !!errors.maxRetryNo && touched.maxRetryNo && errors.maxRetryNo
        }
        InputLabelProps={{ required: true }}
      />
    </FormControl>
  );
};
